import { render, staticRenderFns } from "./mainlandpackage-add.vue?vue&type=template&id=193c469e&"
import script from "./mainlandpackage-add.vue?vue&type=script&lang=ts&"
export * from "./mainlandpackage-add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports